import React, {useCallback} from 'react';
import cx from './index.module.scss';
import ModalPortal from './ModalPortal';

const Modal = ({children, onClose}) => {
  const handleOnKeyUp = useCallback(event => {
    if (event.key === 'Escape' || event.keyCode === 27) {
      onClose();
    }
  }, [onClose]);

  return (
    <ModalPortal>
      <div className={cx.layer} onKeyUp={handleOnKeyUp}>
        <div className={cx.layerBody}>
          {children}
        </div>
        <div className={cx.dimmed} onClick={onClose} />
      </div>
    </ModalPortal>
  )
};

export default Modal;
